<div class="modal-header">
  <h4
    class="truncate-line-2"
    [class.modal-title]="!compact"
    [class.confirmation-title]="compact"
    translate
  >
    {{ title }}
  </h4>

  @if (!compact) {
    <button
      type="button"
      class="btn-close close"
      aria-label="Close"
      aria-describedby="modal-title"
      (click)="activeModal.dismiss(false)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  }
</div>
<div class="modal-body modal-body-confirmation">
  @if (isHtmlMessage) {
    <div
      class="modal-html-content"
      [innerHtml]="message | safeHtml"
    ></div>
  } @else {
    {{ message | translate }}
  }
</div>
@if (shouldShowFooter) {
  <div class="modal-footer">
    <div class="d-flex flex-column w-100">
      @if (checkboxConfirmMessage) {
        <div class="d-flex justify-content-start mb-3">
          <app-check-box
            [elementId]="'checkboxConfirm'"
            [content]="checkboxConfirmMessage"
            (selectItem)="setCheckboxValue($event)"
          ></app-check-box>
        </div>
      }
      <div
        class="d-flex flex-row justify-content-center"
        [class.confirmation-actions]="compact"
      >
        <button
          type="button"
          class="btn"
          [class.flex-1]="compact"
          [class.btn-outline-primary]="!isLeaveSite && !compact"
          [class.btn-outline-secondary]="!isLeaveSite && compact"
          [class.btn-primary]="isLeaveSite"
          [class.border-solid]="!isLeaveSite"
          (click)="cancel()"
        >
          {{ cancelLabel | translate | uppercase }}
        </button>
        @if (confirmBtnDisplayed) {
          <button
            type="button"
            class="btn"
            [class.flex-1]="compact"
            [class.ms-4]="!compact"
            [class.btn-primary]="!isLeaveSite"
            [class.btn-outline-primary]="isLeaveSite"
            [class.border-solid]="isLeaveSite"
            (click)="confirm()"
            [disabled]="checkboxConfirmMessage && !isConfirmMessage"
          >
            {{ confirmLabel | translate | uppercase }}
          </button>
        }
      </div>
    </div>
  </div>
}
